import Car from "./Car/Routes";
import Type from "./Type/Routes/index.js";
import MPInOut from "./MPInOut/Routes";
import MpReport from "./MPReport/Routes";
import Fuel from "./Fuel/Routes";
import Indent from "./Indent/Routes";
import VehicleDrivers from "./VehicleDrivers/Routes";
import Reports from "./Reports/index";

export default [...Car, ...MPInOut, ...MpReport, ...Type, ...Fuel, ...Indent, ...VehicleDrivers, ...Reports];
